import { render } from "./navbar-search.vue?vue&type=template&id=fef7a0c0&scoped=true&lang=pug"
import script from "./navbar-search.vue?vue&type=script&lang=js"
export * from "./navbar-search.vue?vue&type=script&lang=js"

import "./navbar-search.vue?vue&type=style&index=0&id=fef7a0c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef7a0c0"]])

export default __exports__